/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import Spinner from 'apps/Spinner'
import * as styles from './Loading.scss'

const cx = classNames.bind(styles)

interface IProps {
  isLoading?: boolean,
  children?: any,
}

const Loading: React.SFC<IProps> = ({ isLoading, children }) => {
  const isWrapper = !!children
  return isLoading ? (
    <div className={cx(
      'root',
      {
        wrapper: isWrapper,
      },
    )}>
      {children}
      <div className={styles.spinner}>
        <Spinner/>
      </div>
    </div>
  ) : children
}

export default Loading
